import {
    FETCHED_LANGUAGES,
    FETCHED_SITES_LANGUAGES,
    CHANGE_SITE_LANGUAGE,
    UPDATED_SITES_LANGUAGES
} from './types';
import update from 'immutability-helper';

const INITIAL_STATE = {
    allLanguages: [],
    sitesLanguages: [],
    touched: false
};

export default function (state = INITIAL_STATE, action) {
    switch (action.type) {

        case FETCHED_LANGUAGES:

            return update(state, {allLanguages: {
                $set: action.payload.data
            }});

        case UPDATED_SITES_LANGUAGES:

            return update(state, {
                touched: {$set: action.payload.touched}
            });

        case FETCHED_SITES_LANGUAGES:

            let langsSites = [];
            action.payload.data.forEach(site => {
                let siteId = site.id;
                langsSites[siteId] = {};
                site.languages.forEach(language => {
                    langsSites[siteId][language.id] = true;
                });
            });

            return update(state, {sitesLanguages: {
                $set: langsSites
            }});

        case CHANGE_SITE_LANGUAGE:

            let language = {};
            language[action.payload.languageId] = action.payload.checked;

            return update(state, {
                sitesLanguages: {
                    [action.payload.siteId]: {$merge: language }
                },
                touched: {$set: action.payload.touched}
            });

        default:
            return state;
    }
}




// WEBPACK FOOTER //
// ./src/containers/configuration/reducer.js